import { useSession } from '../lib/auth-client';
import { isAdminRole, type Role } from '@bharat-consultancy/shared';

export function useAuth() {
  const { data: session, isPending, error } = useSession();

  const user = session?.user as (typeof session extends null ? never : { role?: Role }) | undefined;
  const role = (user?.role ?? 'customer') as Role;

  return {
    session,
    user: session?.user ?? null,
    isLoading: isPending,
    error,
    isAuthenticated: !!session,
    role,
    isAdmin: isAdminRole(role),
  };
}
